<div class="container sms007">
  <!-- ヘッダーエリア -->
  <app-header></app-header>

  <!-- メインエリア -->
  <div class="main-area">

    <!-- コンテンツエリア -->
    <div class="content-area" [style.width]="windowsWidth">

      <!-- フォームエリア -->
      <form class="sms-form">
        <div [formGroup]="smsForm">

          <br>
          <!-- 文言 -->
          <div>
            <mat-label class="message">{{lblName}}</mat-label>
          </div>
          <br>
          <div>
            <mat-label class="message">{{lblMessage01}}</mat-label>
          </div>
          <br>

          <!-- 文言 -->
          <div>
            <mat-label class="message">{{lblMessage02}}</mat-label>
          </div>
          <br>

          <!-- 退去日 -->
          <div  class="input-area">
            <mat-form-field appearance="standard" class="input-date-yyyy-field ">
              <mat-label>{{lblKaiyakuDateYYYY}}</mat-label>
              <input matInput formControlName="txtTaikyoDateYYYY" class="input-date-yyyy-text" inputmode="tel" tabindex="1" maxlength="4" min="1753" max="9998" />
              <mat-error *ngIf="smsForm.get('txtTaikyoDateYYYY')?.invalid">*</mat-error>
            </mat-form-field>
            <mat-label class="input-date-label">{{lblMessage03}}</mat-label>

            <mat-form-field appearance="standard" class="input-date-mm-field ">
              <mat-label>{{lblKaiyakuDateMM}}</mat-label>
              <input matInput formControlName="txtTaikyoDateMM" class="input-date-mm-text" inputmode="tel" tabindex="2" maxlength="2" min="01" max="12" />
              <mat-error *ngIf="smsForm.get('txtTaikyoDateMM')?.invalid">*</mat-error>
            </mat-form-field>
            <mat-label class="input-date-label">{{lblMessage04}}</mat-label>

            <mat-form-field appearance="standard" class="input-date-dd-field ">
              <mat-label>{{lblKaiyakuDateDD}}</mat-label>
              <input matInput formControlName="txtTaikyoDateDD" class="input-date-dd-text" inputmode="tel" tabindex="3" maxlength="2" min="01" max="31" />
              <mat-error *ngIf="smsForm.get('txtTaikyoDateDD')?.invalid">*</mat-error>
            </mat-form-field>
            <mat-label class="input-date-label">{{lblMessage05}}</mat-label>
          </div>
          <br>
          <br>

          <!-- 文言 -->
          <div>
            <mat-label class="message">{{lblMessage06}}</mat-label>
          </div>
          <div>
            <mat-label class="message">{{lblMessage07}}</mat-label>
          </div>
          <br>
          <div>
            <mat-label class="message">{{lblMessage08}}</mat-label>
          </div>
          <br>
          <br>

          <!-- ボタン -->
          <div class="button-area">
            <button type="submit" mat-raised-button [disabled]="!isEnableBtnSend" (click)="executeClick()" tabindex="4">{{lblBtnSend}}</button>
          </div>

        </div>
      </form>

    </div>
  </div>

  <!-- フッターエリア -->
  <div class="footer-area">
    <div class="img-area">
      <img class="img-logo" src="assets/images/footer_ofi_copyright.png" />
    </div>
    <div class="data-operation-button-area">
      <button type="button" mat-raised-button [disabled]="!isEnableBtnMenu" (click)="backClick()" accesskey="q" tabindex="5">{{lblBtnMenu}}</button>
    </div>
  </div>

</div>
